import React from 'react';
import classes from './style/TestCard.module.css';
import { CheckType } from '../../../../Core/Core';
import { Button } from 'antd';
import { Link } from 'react-router-dom';

interface TestCardProps {
  category_title: string;
  id: number;
  questions_count: number;
  title: string;
  isButtonDelete: boolean;
  themeDelete: (e: React.MouseEvent<HTMLElement, MouseEvent>, id: number) => Promise<void>;
}
const TestCard = (props: TestCardProps) => {
  const { category_title, title, questions_count, id, isButtonDelete, themeDelete } = props;
  const link = isButtonDelete ? `edit-themeTest/${id}` : `edit-attestation/${id}`;
  return (
    <>
      <div className={classes.WrapperCard}>
        <p className={classes.categoryId}>{category_title}</p>
        <div className={classes.title}>
          <p>{title}</p>
        </div>
        <div className={classes.mainContent}>
          <div className={classes.NumberLessons}>
            Количество вопросов: <CheckType type="number" arg={questions_count} />
          </div>
          <div className={classes.ContetnGrup}>
            {isButtonDelete ? (
              <Button
                onClick={(e) => {
                  themeDelete(e, id);
                }}
              >
                Удалить
              </Button>
            ) : (
              <div></div>
            )}
            <Link to={link}>
              <Button type="primary">Редактировать</Button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default TestCard;
